export default {"src":"/_next/static/media/presentations.d543e511.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};